import React, { useState, useRef, Fragment } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import { useOnClickOutside, renderTeamYears } from "../../utils";
import { getCollaboratorsSuggestions } from "../../api";

import LigthPageHeader from "../common/PageHeader/LigthPageHeader";
import { TiArrowSortedDown } from "react-icons/ti";

import "./CollaboratorSpace.local.scss";

const CollaboratorSpaceHeader = ({
  collaboratorSpace = null,
  onChangeCollaborator,
  navCommunity,
  onChangeYear,
  collaborator,
  token,
  year,
}) => {
  const refYears = useRef();
  useOnClickOutside(refYears, () => setYearDivIsVisible(false));

  const refCollabs = useRef();
  useOnClickOutside(refCollabs, () => setCollabDivIsVisible(false));
  const { language } = useSelector((state) => state.params);

  //Header
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  const [collabDivIsVisible, setCollabDivIsVisible] = useState(false);
  const [collaboratorOptions, setCollaboratorOptions] = useState([]);

  let collaboratorsQuery = useQuery(
    ["getCollaborators", token, navCommunity],
    async () => {
      if (token && navCommunity?.id) {
        try {
          const response = await getCollaboratorsSuggestions(
            token,
            navCommunity.id
          );
          let data = response.data.data
            .filter((item) => item !== null)
            .map((t) => {
              return {
                value: t.id,
                label: t.name,
              };
            });
          setCollaboratorOptions(data);
        } catch (e) {
          return null;
        }
      }
    }
  );

  const renderHeaderAction = () => {
    console.log(collaborator);
    return (
      <Fragment>
        <div
          ref={refCollabs}
          className={
            "customed_select" +
            " " +
            (collabDivIsVisible ? "customed_select_opened" : "")
          }
          style={{
            width: "fit-content",
            background: "#6d7f92",
            color: "#ffffff",
          }}>
          <div className={"customed_select_header"}>
            <span>{collaborator ? collaborator.name : ""}</span>
            <div className={"actions"}>
              <div>
                <span
                  className={"action"}
                  onClick={() => setCollabDivIsVisible(!collabDivIsVisible)}>
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {collabDivIsVisible && (
            <div className={"customed_select_body"}>
              <div className={"customed_select_body_options"}>
                {collaboratorOptions.map((item, index) => (
                  <div
                    key={index}
                    className={"customed_select_body_option"}
                    onClick={() => {
                      setCollabDivIsVisible(false);
                      onChangeCollaborator(item.value);
                    }}>
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div
          ref={refYears}
          className={
            "customed_select" +
            " " +
            (yearDivIsVisible ? "customed_select_opened" : "")
          }
          style={{
            background: "#6d7f92",
            color: "#ffffff",
          }}>
          <div className={"customed_select_header"}>
            <span>{year}</span>
            <div className={"actions"}>
              <div>
                <span
                  className={"action"}
                  onClick={() => setYearDivIsVisible(!yearDivIsVisible)}>
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {yearDivIsVisible && (
            <div className={"customed_select_body"}>
              <div className={"customed_select_body_options"}>
                {renderTeamYears().map((item, index) => (
                  <div
                    key={index}
                    className={"customed_select_body_option"}
                    onClick={() => {
                      onChangeYear(item);
                      setYearDivIsVisible(false);
                    }}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  };

  return (
    !collaboratorSpace && (
      <LigthPageHeader
        title={{
          label: "ficheCollaborator",
          value: collaborator ? collaborator.name : "",
        }}
        goBack={`/${language}/collaborators`}>
        {renderHeaderAction()}
      </LigthPageHeader>
    )
  );
};

export default CollaboratorSpaceHeader;
